import React from 'react'
import { FormattedMessage } from 'react-intl'
import AddIcon from '@material-ui/icons/Add'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  notesPanel: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  notesPanelTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#404040',
  },
  notesPanelAddBtn: {
    color: '#247bcd',
    cursor: 'pointer',
  },
}))

export default (props) => {
  let { openOrCloseCreateDialog } = props
  const styleClass = useStyles()

  return (
    <div className={styleClass.notesPanel}>
      <div className={styleClass.notesPanelTitle}>
        <FormattedMessage id="note.title" />
      </div>
      <div
        className={styleClass.notesPanelAddBtn}
        onClick={openOrCloseCreateDialog}
      >
        <AddIcon />
      </div>
    </div>
  )
}
